export default function ApiError() {
  return (
    <div className="alert-area">
      <div className="alert alert-danger d-flex align-items-center border-danger" role="alert">
        <span className="material-icons flex-shrink-0 me-2 fs-4 text-danger">error</span>

        <div className="alert-text">
          <p>Something went wrong on our end, please try again later!</p>
        </div>
      </div>
    </div>
  );
}
